import type { FC } from 'react';
import paw from './assets/paw.svg';
import * as Styled from './styled';
import type { BulletListProps } from './types';

export * from './types';

export const BulletList: FC<BulletListProps> = (props) => {
  const { items = [], iconImg = paw } = props;

  return (
    <Styled.Wrapper>
      {items.map((item, index) => (
        <Styled.Item key={index}>
          <Styled.Icon src={iconImg} />
          {item}
        </Styled.Item>
      ))}
    </Styled.Wrapper>
  );
};
